import { useWtrSelector } from 'redux/hooks';
import { getProductById } from 'redux/modules/entities/selectors/products';
import concatenatePromotionValues from 'redux/middleware/analytics/actions-to-track/utilities/concatenate-promotion-values';
import { getProductFindingMethod } from 'utils/get-product-finding-method';
import {
  type AdMetadata,
  EventType,
  metadataAdImpressions,
  sendAdTechEvent,
} from 'analytics/gtmServerFunctions';
import { addProductImpression } from 'analytics/product-impressions-tracking';
import { usePodObserver } from './use-pod-observer';

interface PodContext {
  metadata?: AdMetadata;
  position: number;
  productId: string;
  searchType: string | null;
  sponsorshipId?: string;
  trackingUrls?: string[];
  wrapperId: string;
}

export function usePodImpression(
  { metadata, position, productId, searchType, sponsorshipId, trackingUrls, wrapperId }: PodContext,
  sponsored?: boolean,
) {
  // TODO: Migrate all product to impression mapping to a shared selector utility
  // REF: https://johnlewispartnership.atlassian.net/browse/SHOPEXP-90
  const { currentSaleUnitPrice, defaultQuantity, lineNumber, name, promotions } = useWtrSelector(
    state =>
      // @ts-expect-error entities selectors are not typed
      getProductById(state, productId),
  );
  const offer = useWtrSelector(state => concatenatePromotionValues(state, promotions)) || '';
  const currencyCode = currentSaleUnitPrice.price.currencyCode || '';
  const price = currentSaleUnitPrice.price.amount || '';
  const uom = defaultQuantity.uom || '';
  const list = (wrapperId || searchType || '').toLowerCase();
  const productFindingMethod = getProductFindingMethod();

  return usePodObserver((element: HTMLElement) => {
    sendAdTechEvent({
      eventType: EventType.IMPRESSION,
      trackingUrls,
      sponsorshipId,
    });

    if (metadata) {
      metadataAdImpressions(metadata);
    }

    addProductImpression({
      currencyCode,
      element,
      id: productId,
      lineNumber,
      list,
      name,
      offer,
      position,
      price,
      productFindingMethod,
      sponsored,
      sponsorshipId,
      uom,
    });
  });
}
